import gql from 'graphql-tag'

export default gql`
  mutation redecisionLoan($input: RedecisionLoanInput!) {
    redecisionLoan(input: $input) {
      loan {
        state
        smartRate
        predictionResults {
          riskRating
          smartRate
          id
          topAttrs
          createdAt
          predictionModel {
            dataPermutation
            version
            type
          }
        }
      }
    }
  }
`
